module.exports = __webpack_public_path__ + "static/media/201IT248.7d7cb2db.jpg";